import * as HLF from "html-living-framework";
import {Callback} from "../core/Reflection";
import {StoryInjection} from "../data/StoryModel";
import {StoryCreator} from "../states/StoryCreator";

export class SceneInjectionChain implements StoryInjection {

    private readonly injections: StoryInjection[];

    constructor(...injections: StoryInjection[]) {
        this.injections = injections;
    }

    public execute(storyCreator: StoryCreator, cb: Callback) {
        const i = this.injections.slice();
        const e = () => {
            if (i.length > 0) {
                i.shift()!.execute(storyCreator, e);
            } else {
                cb();
            }
        };
        e();
    }

    public getAssets(): Array<HLF.IAsset<any>> {
        return this.injections.reduce<Array<HLF.IAsset<any>>>((a, t) => {
            a.push(...t.getAssets());
            return a;
        }, []);
    }
}
